import { DotLoading, Swiper } from "antd-mobile";
import { formatDate } from "@/utils";
import classNames from "classnames";
import { useBannersCtrl, useBannersHook } from "@/hooks/dk-hooks/useBanners";

interface NewsItem1 {
  id: string;
  image: string;
  title: string;
  addtime: number;
  media: string;
}
export default function NewsItem() {
  const navigate = useNavigate();
  const { loadBannerList } = useBannersHook();
  const { resData } = useBannersCtrl();
  useEffect(() => {
    loadBannerList();
  }, []);

  const handleNewsDetail = (id: any) => {
    navigate(`/news/detail?id=${id}`, {
      replace: false,
    });
  };

  const data = Array.isArray(resData) ? resData : [];
  if (data.length === 0) {
    return (
      <div className="p-[0_16px]">
        <DotLoading />
      </div>
    );
  }

  const items = (resData as NewsItem1[]).map((it, idx) => (
    <Swiper.Item key={idx}>
      <div onClick={() => handleNewsDetail(it.id)} className="w-full h-228 rounded-0 bg-[var(--app-bg-22)] relative">
        <div
          className={classNames([
            "w-full h-[calc(228px-81px)] rounded-0 object-[50%_50%] bg-no-repeat bg-cover bg-center",
          ])}
          style={{
            backgroundImage: `url(${it.image})`,
          }}
        ></div>

        <div className="bg-[var(--app-bg-01)] w-full h-81 absolute bottom-0 left-0 rounded-0">
          <div className="text-ellipsis-2 absolute top-19 left-16 w-296px font-500 text-14 color-[var(--app-text-08)]">
            {it.title}
          </div>
          <div className="absolute top-57 left-16 font-400 text-12 color-[var(--app-text-09)]">
            {formatDate(it.addtime)} · {it.media}
          </div>
        </div>
      </div>
    </Swiper.Item>
  ));
  return (
    <div className="swiper-container-01">
      <Swiper loop autoplay={true} autoplayInterval={2000}>
        {items}
      </Swiper>
    </div>
  );
}
